import { COOKIES } from '@/constants/cookies';
import Cookies from 'js-cookie';

export default function getVisitorId() {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return Cookies.get(COOKIES.NAMES.VISITOR_ID);
}
